// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "物业租售估价",
        "tec": "穆林林",
        "week": "1-9,11-12周",
        "add": "教学楼D座323文法"
      },
      {
        "sub": "劳动与创造",
        "tec": "王庆喜",
        "week": "10周",
        "add": "教学楼D座327经管"
      }
    ],
    [
      {
        "sub": "物业会计",
        "tec": "王海燕",
        "week": "1-9,11-13周",
        "add": "教学楼D座315文法"
      },
      {
        "sub": "劳动与创造",
        "tec": "王庆喜",
        "week": "10周",
        "add": "教学楼D座327经管"
      }
    ],
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "孙新",
      "week": "1-8周",
      "add": "教学楼A座122信息"
    },
    {
      "sub": "能源电力工程与绿色低碳技术",
      "tec": "黄玉东张翼",
      "week": "1-8周",
      "add": "教学楼C座212教务"
    },
    0
  ],
  "2": [
    [
      {
        "sub": "物业管理信息系统及运用",
        "tec": "赵扬",
        "week": "1-9,11-13周",
        "add": "实训楼E座417管理机房"
      },
      {
        "sub": "劳动与创造",
        "tec": "王庆喜",
        "week": "10周",
        "add": "教学楼D座328经管"
      }
    ],
    {
      "sub": "劳动与创造",
      "tec": "王庆喜",
      "week": "10周",
      "add": "教学楼D座328经管"
    },
    0,
    {
      "sub": "国家安全教育",
      "tec": "孙新",
      "week": "8-9,11-12周",
      "add": "教学楼A座122信息"
    },
    0
  ],
  "3": [
    {
      "sub": "物业客户服务",
      "tec": "刘静",
      "week": "1-9,11-13周",
      "add": "教学楼D座315文法"
    },
    {
      "sub": "物业会计",
      "tec": "王海燕",
      "week": "1-9,11-13周",
      "add": "教学楼D座317文法"
    },
    0,
    {
      "sub": "物业管理专业英语",
      "tec": "韩英焕",
      "week": "1-9,11-13周",
      "add": "实训楼E座414管理"
    },
    0
  ],
  "4": [
    {
      "sub": "物业租售估价",
      "tec": "穆林林",
      "week": "2,4,6,8,12周",
      "add": "教学楼D座323文法"
    },
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "孙新",
      "week": "1-8周",
      "add": "教学楼A座222电力"
    },
    {
      "sub": "就业创业指导",
      "tec": "王星月",
      "week": "2-6周",
      "add": "教学楼D座315文法"
    },
    {
      "sub": "物业管理案例分析",
      "tec": "赵扬",
      "week": "1-8周",
      "add": "教学楼D座315文法"
    },
    0
  ],
  "5": [
    {
      "sub": "物业管理信息系统及运用",
      "tec": "赵扬",
      "week": "1-9,11-13周",
      "add": "实训楼E座417管理机房"
    },
    {
      "sub": "物业客户服务",
      "tec": "刘静",
      "week": "1-9,11-13周",
      "add": "教学楼D座315文法"
    },
    {
      "sub": "国家安全教育",
      "tec": "孙新",
      "week": "8-9,11-12周",
      "add": "教学楼A座322电力"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
